<template>
  <div>
    <form @submit="submitForm">
      <div class="card card-custom">
        <h4 class="card-header">Manage</h4>
        <div class="card-body">
          <h3>General Information</h3>
          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label">Category</label>
              <v-select placeholder="--Select--" label="Title" :options="categories" v-model="form.BP_ORGCATEGORY" :reduce="x=>x.ID" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Partner Type</label>
              <v-select placeholder="--Select--" label="Title" :options="partnerTypes" v-model="form.PTR_ID" :reduce="x=>x.ID" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Status</label>
              <v-select placeholder="--Select--" label="Title" :options="statuses" v-model="form.PST_ID" :reduce="x=>x.ID" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Tax</label>
              <v-select placeholder="--Select--" label="Title" :options="taxes" v-model="form.TX_ID" :reduce="x=>x.ID" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Tax Payer</label>
              <select class="form-control" v-model="form.BP_ISACTTAXPAY" required>
                <option value="">Select Tax Payer</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label class="form-label">Business Nature</label>
              <v-select placeholder="--Select--" label="Title" :options="businessNatures" v-model="form.BN_ID" :reduce="x=>x.ID" />
            </div>
          </div>
          <h3>Personal Information</h3>
          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label">Title</label>
              <v-select placeholder="--Select--" label="Title" :options="titles" v-model="form.PT_ID" :reduce="x=>x.ID" />
            </div>
            <div class="form-group col-md-9">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" v-model.trim="form.BP_DSC" required />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Passport</label>
              <input type="text" class="form-control" v-model="form.BP_PASSPORTNO" required />
            </div>
            <div v-if="form.PTR_ID != 1 && form.PTR_ID != 17" class="form-group col-md-3">
              <label class="form-label">GST</label>
              <input type="text" class="form-control" v-model="form.BP_GST_NO" required />
            </div>
            <div class="form-group col-md-3" v-if="form.PTR_ID == 1 || form.PTR_ID == 17">
              <label class="form-label">NIC</label>
              <input type="text" class="form-control" maxlength="13" v-model="form.BP_NIC_NO" required />
            </div>
            <div class="form-group col-md-3" v-if="form.PTR_ID != 1 && form.PTR_ID != 17">
              <label class="form-label">NTN</label>
              <input type="text" class="form-control" maxlength="13" v-model="form.BP_NTN_NO" required />
            </div>
          </div>

          <h3>Contact Information</h3>
          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label">Country</label>
              <v-select placeholder="--Select--" label="Title" :options="countries" v-model="form.C_CODE" :reduce="x=>x.ID" @input="fetchStates" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">State</label>
              <v-select placeholder="--Select--" label="Title" :options="states" v-model="form.PVN_ID" :reduce="x=>x.ID" @input="fetchCities" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">City</label>
              <v-select placeholder="--Select--" label="Title" :options="cities" v-model="form.CTY_ID" :reduce="x=>x.ID" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Contact Person</label>
              <input type="text" class="form-control" v-model="form.BP_CONTACT_PERSON" required />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Mobile No</label>
              <input type="tel" class="form-control" v-model="form.BP_MOBILE" required />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Phone No</label>
              <input type="tel" class="form-control" v-model="form.BP_PHONE" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Fax No</label>
              <input type="tel" class="form-control" v-model="form.BP_FAX" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">P.O BOX</label>
              <input type="text" class="form-control" v-model="form.BP_PO_BOX" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" v-model="form.BP_EMAIL_ADDRESS" required />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Website</label>
              <input type="text" class="form-control" v-model="form.BP_URL_ADDRESS" />
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">UAN No</label>
              <input type="tel" class="form-control" v-model="form.BP_UAN" />
            </div>
          </div>
          <h3>Address</h3>
          <table class="col-md-12 table-sm table-bordered">
            <thead class="bg-custom">
              <tr>
                <th>Sr.No</th>
                <th>Address</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(address, index) in addresses" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input class="form-control" v-model="address.ADD_ADDRESS" placeholder="Enter address" required />
                </td>
                <td>
                  <input type="checkbox" v-model="address.ADD_ISACTIVE" :true-value="1" :false-value="0" />
                  {{ address.ADD_ISACTIVE ? 'Active' : 'Inactive' }}
                </td>
                <td>
                  <button type="button" class="btn btn-danger" @click="removeAddress(index)" :disabled="addresses.length === 1">
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4">
                  <button type="button" class="btn btn-block btn-secondary" @click="addAddress">
                    Add Another Address
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-success float-right mr-1">Submit</button>
          <button type="button" class="btn btn-danger float-right mr-1" @click="clearForm">Clear</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        addresses: [{
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        }],
        ALLOTMENT: [{
          BA_ID: null,
          BP_ID: null,
          BA_BRANCH: '',
          BA_ISACTIVE: 1
        }], //SAME AS ASSIGN
        form: {
          BP_ORGCATEGORY: '',   //category
          PTR_ID: '',           //PartnerType
          PST_ID: '',           //Status
          TX_ID: '',            //Tax
          BP_ISACTTAXPAY: '',   //taxPayer
          BN_ID: '',            //businessNatures
          PT_ID: '',            //title
          BP_DSC: '',           //Name
          BP_PASSPORTNO: '',    //Passport
          BP_GST_NO: '',
          BP_NIC_NO: '',
          BP_NTN_NO: '',
          C_CODE: '',            //country
          PVN_ID: '',            //state
          CTY_ID: '',            //city
          BP_CONTACT_PERSON: '',
          BP_MOBILE: '',
          BP_PHONE: '',
          BP_FAX: '',
          BP_PO_BOX: '',
          BP_EMAIL_ADDRESS: '',
          BP_URL_ADDRESS: '',    //website
          BP_UAN: '',

        },
        categories: [],
        partnerTypes: [],
        statuses: [],
        taxes: [],
        businessNatures: [],
        titles: [],
        countries: [],
        states: [],
        cities: [],
      };
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id') ? urlParams.get('id') : 0;
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clean_uri);
        }
        startReq();
        axios.get("/api/IMSApi/pageLoadInsured?id=" + id)
          .then(function (res) {
            endReq();
            vm.categories = res.data.categories;
            vm.partnerTypes = res.data.partnerTypes;
            vm.statuses = res.data.statuses;
            vm.taxes = res.data.taxes;
            vm.businessNatures = res.data.businessNatures;
            vm.titles = res.data.titles;
            vm.countries = res.data.countries;
            if (res.data.obj != null) {
              vm.form = res.data.obj;
              vm.addresses = res.data.add;
              vm.ALLOTMENT = res.data.branchAllot;
            }
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      fetchStates() {
        var vm = this;
        axios.get('/api/IMSApi/GetStates?countryId=' + vm.form.country)
          .then(function (res) {
            endReq();
            vm.states = res.data.states;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },

      fetchCities() {
        var vm = this;
        axios.get('/api/IMSApi/GetCities?stateId=' + vm.form.state)
          .then(function (res) {
            endReq();
            vm.cities = res.data.cities;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      addAddress() {
        this.addresses.push({
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        });
      },
      removeAddress(index) {
        if (this.addresses.length > 1) {
          this.addresses.splice(index, 1);
        }
      },
      submitForm() {
        console.log('Form submitted:', this.form);
      },
      clearForm() {
        this.addresses = [{
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        }],
          this.ALLOTMENT = [{ BA_BRANCH: '' }],
          this.form = {
            BP_ID: 0,
            BP_ORGCATEGORY: '', //category
            PTR_ID: '', //PartnerType
            PST_ID: '', //Status
            TX_ID: '', //Tax
            BP_ISACTTAXPAY: '1', //taxPayer
            BN_ID: '', //businessNatures
            PT_ID: '', //title
            BP_DSC: '', //Name
            BP_PASSPORTNO: '', //Passport
            BP_GST_NO: '',
            BP_NIC_NO: '',
            BP_NTN_NO: '',
            C_CODE: '', //country
            PVN_ID: '', //state
            CTY_ID: '', //city
            BP_CONTACT_PERSON: '',
            BP_MOBILE: '',
            BP_PHONE: '',
            BP_FAX: '',
            BP_PO_BOX: '',
            BP_EMAIL_ADDRESS: '',
            BP_URL_ADDRESS: '', //website
            BP_UAN: '',

          };
        window.location.reload();
      },
      submitForm(e) {
        var vm = this;
        e.preventDefault();
        startReq();

        axios.post('/api/IMSApi/saveInsured', {
          BPMain: vm.form,
          address: vm.addresses,
          allotment: vm.ALLOTMENT,
        })
          .then(response => {
            endReq();
            if (response.data.status) {
              toastr.success(response.data.msg)
              vm.clearForm();
            }
            else {
              toastr.error(response.data.msg)

            }
          })
          .catch(error => {
            endReq();
            vm.error = 'Error saving Insured';
            console.log(error);
          })
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ims/Insured.vue